import styles from 'commons/js/theme/google-maps-style.json'
const MAX_ZOOM = 20
const MIN_ZOOM = 4

const mapOptions = {
    scaleControl: true,
    zoomControl: true,
    zoomControlOptions: {
        position: 5, // Top left
    },
    featureType: 'road',
    mapTypeControl: false,
    fullscreenControl: false,
    streetViewControl: false,
    scrollwheel: false,
    maxZoom: MAX_ZOOM,
    minZoom: MIN_ZOOM,
    clickableIcons: false,
    styles,
}

export default mapOptions
